const persistedTime = value => {
  const time = Date.parse(value || '');
  return Number.isFinite(time) ? time : null;
};

export function shouldAcceptStatusContext(current, incoming) {
  const incomingId = incoming?.id ? String(incoming.id) : null;
  const incomingTime = persistedTime(incoming?.createdAt);
  if (!incomingId || incomingTime == null) return false;
  if (!current?.id) return true;
  const currentTime = persistedTime(current.createdAt);
  if (currentTime == null) return false;
  if (incomingTime !== currentTime) return incomingTime > currentTime;
  return incomingId > String(current.id);
}
